import { useEffect, useRef } from 'react';

// Ref-based reduced-motion detector. Read inside useFrame; never
// causes re-renders.
export function useReducedMotion(): React.MutableRefObject<boolean> {
  const reduced = useRef(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => {
      reduced.current = mq.matches;
    };
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return reduced;
}
